import React from 'react';
import 'twin.macro';

interface Props {
  id?: string;
  children?: React.ReactNode;
  className?: string;
}

export function Description(props: Props) {
  const { id, children, className } = props;
  return (
    <p id={id} tw="text-neutral-moderate" className={className}>
      {children}
    </p>
  );
}
